import {WsInsuranceCategoryOptionalFeature} from '@lifeislife/lifeislife-ws-api';

export type InsuranceCategoryOptionalFeature = WsInsuranceCategoryOptionalFeature;
export const InsuranceCategoryOptionalFeature = WsInsuranceCategoryOptionalFeature;
